import { render, staticRenderFns } from "./KleptOS.vue?vue&type=template&id=10b9d362&scoped=true&"
import script from "./KleptOS.vue?vue&type=script&lang=js&"
export * from "./KleptOS.vue?vue&type=script&lang=js&"
import style0 from "./KleptOS.vue?vue&type=style&index=0&id=10b9d362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9d362",
  null
  
)

export default component.exports